/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function clearSearchBar() {
  document.getElementsByClassName("header-search__input")[0].value = "";
}

window.addEventListener("videeo:add-to-cart", videeoAddToCartEventHandler);
function videeoAddToCartEventHandler() {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );
  var cartDrawerButtonSelector =
    "Header__Icon Icon-Wrapper Icon-Wrapper--clickable ";
  var cartDrawerButton = document.getElementsByClassName(
    cartDrawerButtonSelector
  )[4];
  cartDrawerButton.click();
}

function chkX() {
  var element = document.getElementById("agrAbve");
  if (element.checked == true) {
    document.getElementById("agrAbveBtn").disabled = false;
    document.getElementById("agrAbveBtn").classList.remove("Button--disabled");
  } else {
    document.getElementById("agrAbveBtn").disabled = true;
    document.getElementById("agrAbveBtn").classList.add("Button--disabled");
  }
}

function myFpTrLL($event, $id, $variantID) {
  console.log("added" + $id);
  console.log("added" + $variantID);
  // Get the checkbox
  var checkBox = document.getElementById($id + "Check");
  if (checkBox.checked == true) {
    var addData = { quantity: 1, id: $variantID };
    fetch("/cart/add.js", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With":
          "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
      },
      method: "POST",
    })
      .then(function (response) {
        if (response.ok) {
          var node = document.createElement("p"); // Create a <li> node
          var textnode = document.createTextNode("Thank you!");
          node.appendChild(textnode); // Create a text node
          document.getElementById($id + "-thx").appendChild(node);
          setTimeout(function () {
            window.location.href = "/cart";
          }, 1000);
        } else {
          console.log(response);
        }
      })
      .then((data) => {
        return data;
      });
  }
}

// $(".announcement_carousel").flickity({
//     wrapAround: true,
//     freeScroll: true,
//     pageDots: false,
//     prevNextButtons: false,
//     autoPlay: 3000,
//   });

//  setTimeout(function() {
// $(".video-slider").flickity({
//   contain: true,
//   wrapAround: false,
//   freeScroll: true,
//   pageDots: true,
//   prevNextButtons: false,
//   watchCSS: false,
//   dragThreshold: 8,
//   groupCells: true,
//   arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25},
// });
//  },500);

// $('.membership-product-carousel').flickity({
//   cellAlign: 'center',
//   contain: true,
//   wrapAround: false,
//   freeScroll: true,
//   pageDots: true,
//   prevNextButtons: true,
//   watchCSS: false,
//   dragThreshold: 8,
//   groupCells: true,
//   arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25},
// });

//dropdown js
var timeSelected = "";
var countrySelected = "";
$(".opportunities-sec .country-select [name=country_id]").on(
  "change",
  function () {
    countrySelected = $(this).val();
    if (timeSelected) {
      $(".opportunities-items").hide();
      $(
        '.opportunities-items[data-location="' +
          countrySelected +
          '"][data-contract="' +
          timeSelected +
          '"]'
      ).show();
    }
    if (countrySelected == "0" && timeSelected == "0") {
      $(".opportunities-items").show();
    }
  }
);

$(".opportunities-sec .time-select [name=time_id]").on("change", function () {
  timeSelected = $(this).val();
  $(".opportunities-items").hide();
  $(
    '.opportunities-items[data-location="' +
      countrySelected +
      '"][data-contract="' +
      timeSelected +
      '"]'
  ).show();
  if (countrySelected == "0" && timeSelected == "0") {
    $(".opportunities-items").show();
  }
});

//product carousel
// $('.product-list-flickity-carousel').flickity({
//   cellAlign: 'center',
//   contain: true,
//   wrapAround: false,
//   freeScroll: true,
//   pageDots: false,
//   prevNextButtons: true,
//   dragThreshold: 8,
//   groupCells: 4,
//   arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25},
// });

$(".announcement_carousel").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  dots: false,
  infinite: true,
  speed: 1000,
});

$(".video-slider").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  infinite: false,
  arrows: false,
  prevArrow:
    '<i class="slick-prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></i>',
  nextArrow:
    '<i class="slick-next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></i>',
  responsive: [
    {
      breakpoint: 1140,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 642,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".membership-product-carousel").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  infinite: false,
  arrows: true,
  prevArrow:
    '<i class="slick-prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></i>',
  nextArrow:
    '<i class="slick-next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></i>',
  responsive: [
    {
      breakpoint: 1501,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 2,
        arrows: false,
      },
    },
  ],
});
$(".product-list-carousel").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  dots: true,
  infinite: false,
  arrows: true,
  prevArrow:
    '<i class="slick-prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></i>',
  nextArrow:
    '<i class="slick-next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></i>',
  responsive: [
    {
      breakpoint: 1140,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 642,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(document).one("click", ".live-shopping-btn .button", function () {
  setTimeout(function(){
    $(".how_to_use_mobile_slider").slick({
      centerMode: true,
      centerPadding: '180px',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      arrows: false,
      responsive: [
         {
          breakpoint: 910,
          settings: {
            centerPadding: '200px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 800,
          settings: {
            centerPadding: '180px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            centerPadding: '160px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 641,
          settings: {
            centerPadding: '140px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 575,
          settings: {
            centerPadding: '100px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 500,
          settings: {
            centerPadding: '80px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 426,
          settings: {
            centerPadding: '40px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 374,
          settings: {
            centerPadding: '10px',
            slidesToShow: 1,
          },
        },
      ],
    });
  }, 500);
});

// opportunuty page js
$(".TestimonialList").slick({
  arrows: false,
  autoplay: true,
  centerMode: false,
  infinite: true,
  rows: 0,
  slidesToShow: 1,
  vertical: true,
  verticalSwiping: true,
  slidesToScroll: 1,
  dots: false,
  easing: "linear",
  cssEase: "linear",
  infinite: false,
});

function chkX() {
  var element = document.getElementById("agrAbve");
  if (element.checked == true) {
    document.getElementById("agrAbveBtn").disabled = false;
    document.getElementById("agrAbveBtn").classList.remove("button-disabled");
  } else {
    document.getElementById("agrAbveBtn").disabled = true;
    document.getElementById("agrAbveBtn").classList.add("button-disabled");
  }
}
$(document).ready(function() {
  if ($(this).scrollTop() > 100) {
    $(':has(.shopify-section:first-child [allow-transparent-header]):not(:has(.shopify-section--header+.shopify-section-group-header-group)) .header:not(:hover,:has([open]))').addClass('sticky_header');
  } else {
    $(':has(.shopify-section:first-child [allow-transparent-header]):not(:has(.shopify-section--header+.shopify-section-group-header-group)) .header:not(:hover,:has([open]))').removeClass('sticky_header');
  }
});
$(window).scroll(function() {
  if ($(this).scrollTop() > 100) {
    $(':has(.shopify-section:first-child [allow-transparent-header]):not(:has(.shopify-section--header+.shopify-section-group-header-group)) .header:not(:hover,:has([open]))').addClass('sticky_header');
  } else {
    $(':has(.shopify-section:first-child [allow-transparent-header]):not(:has(.shopify-section--header+.shopify-section-group-header-group)) .header:not(:hover,:has([open]))').removeClass('sticky_header');
  }
});

/* ===================== loose stone option ===================== */
(function () {
  function isCartPage() {
    return window.location.pathname === "/cart";
  }

  // The Loose Stone and its linked Setting Service both store this same timestamp (as properties[_setting_id]) so
  // the relationship survives AJAX cart updates, page refreshes and the Shopify order without depending on any DOM/form ID.
  function generateSettingId() {
    return `${Date.now()}`;
  }

  function parseExistingProperties(wrapper) {
    const existingProperties = {};
    if (wrapper && wrapper.dataset.properties) {
      const parsedProperties = JSON.parse(wrapper.dataset.properties);
      Object.entries(parsedProperties).forEach(([key, val]) => {
        if (Array.isArray(val) && val.length === 2) {
          existingProperties[val[0]] = val[1];
        } else {
          existingProperties[key] = val;
        }
      });
    }
    return existingProperties;
  }

  function prepareBundledSections() {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));
    return sectionsToBundle;
  }

  function dispatchLoadingStart() {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  }

  function dispatchLoadingEnd() {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  }

  function dispatchCartChange(cart, baseEvent) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: { baseEvent: baseEvent || "line-item:change", cart }
    }));
  }

  async function waitForVariantPickerProduct(picker, timeout) {
    const start = Date.now();
    while (picker && !picker.product && Date.now() - start < (timeout || 3000)) {
      await new Promise((resolve) => setTimeout(resolve, 30));
    }
    return !!(picker && picker.product);
  }

  /**
   * Forces a variant-picker (bound to the given form) to reflect a specific variant, reusing the theme's own
   * master-selector -> option-selector sync (VariantPicker#onMasterSelectorChanged) instead of re-implementing it.
   */
  async function preselectSettingVariant(formId, variantId, scope) {
    if (!formId || !variantId) return;

    const picker = scope?.querySelector("variant-picker") || document.querySelector(`variant-picker[form="${CSS.escape(formId)}"]`);
    const form = scope?.querySelector("form") || document.getElementById(formId);
    if (!picker || !form || !form.id) return;

    const ready = await waitForVariantPickerProduct(picker);
    if (!ready) return;

    if (String(form.id.value) !== String(variantId)) {
      form.id.value = variantId;
      form.id.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Also reflect the resolved variant back into the split Jewellery type / Setting style / Metal dropdowns
    // (cart drawer/page only - the product page always starts from these dropdowns instead of a linked variant).
    if (scope) {
      const variant = picker.product.variants.find((candidate) => String(candidate.id) === String(variantId));
      preselectSettingServicePicker(scope, variant, {
        "Ring size": scope.dataset.parentRingSize,
        "Stud Style": scope.dataset.parentStudStyle
      });
    }
  }

  function getSettingVariant(formId, scope) {
    const picker = scope?.querySelector("variant-picker") || document.querySelector(`variant-picker[form="${CSS.escape(formId)}"]`);
    const form = scope?.querySelector("form") || document.getElementById(formId);
    if (!picker || !picker.product || !form || !form.id) return null;
    return picker.product.variants.find((variant) => String(variant.id) === String(form.id.value)) || null;
  }

  /* ================================================================================================================
     SETTING SERVICE PICKER (shared): drives the Jewellery type / Setting style / Metal dropdowns and the hidden
     real variant-picker they control. Used by both the product page's Setting Required flow and the cart drawer/
     page's setting-service-modal - see snippets/setting-service-picker.liquid for the matching markup.
     ================================================================================================================ */
  function getSettingServicePickerFields(root) {
    return {
      jewelleryTypeSelect: root.querySelector('select[name="properties[Jewellery type]"]'),
      settingStyleSelect: root.querySelector('select[name="properties[Setting style]"]'),
      metalSelect: root.querySelector('select[name="properties[Metal]"]'),
      conditionalFields: root.querySelectorAll("[data-jewellery-conditional]"),
      realVariantPickerRoot: root.querySelector("[data-real-variant-picker]")
    };
  }

  function findSettingServiceOptionInput(realVariantPickerRoot, optionName) {
    if (!realVariantPickerRoot) return null;

    const fieldsets = realVariantPickerRoot.querySelectorAll(".variant-picker__option");
    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector("legend");
      if (legend && legend.textContent.replace(":", "").trim().toLowerCase() === optionName.toLowerCase()) {
        return fieldset.querySelector('input[name^="option"]');
      }
    }
    return null;
  }

  // A conditional field's data-jewellery-conditional holds one or more "|"-separated keywords (e.g. "ring", or
  // "stud|studs|earring|earrings"). Matching is case/whitespace-insensitive and compares whole words, so real
  // Setting Service data doesn't have to spell a jewellery type exactly like the keyword - "Studs",
  // "Moi et Toi Ring" etc. all resolve correctly without listing every variant here.
  //
  // This must be whole-word, not raw substring, matching: "ring" is literally a substring of "earring", so a
  // naive .includes() check would make the Style field's "earring"/"earrings" keywords also match a jewellery
  // type of exactly "Ring" - showing both Ring size and Style at once instead of just Ring size.
  function jewelleryTypeMatchesConditional(jewelleryType, conditionalKeywords) {
    if (!jewelleryType || !conditionalKeywords) return false;
    const typeWords = jewelleryType.trim().toLowerCase().split(/\s+/);

    return conditionalKeywords.split("|").some((keyword) => {
      const normalizedKeyword = keyword.trim().toLowerCase();
      if (!normalizedKeyword) return false;
      return typeWords.includes(normalizedKeyword);
    });
  }

  function findActiveConditionalField(conditionalFields, jewelleryType) {
    return Array.from(conditionalFields).find((field) => jewelleryTypeMatchesConditional(jewelleryType, field.dataset.jewelleryConditional));
  }

  // Shows/hides jewellery-type-specific fields (Ring size, Stud Style, ...). `gate` lets a caller layer an extra
  // condition on top - the product page only shows these once "Yes" is selected; the cart modal has no such gate.
  function toggleJewelleryConditionalFields(root, gate) {
    const { jewelleryTypeSelect, conditionalFields } = getSettingServicePickerFields(root);
    const jewelleryType = jewelleryTypeSelect ? jewelleryTypeSelect.value : "";

    conditionalFields.forEach((field) => {
      const matches = !!gate && jewelleryTypeMatchesConditional(jewelleryType, field.dataset.jewelleryConditional);
      field.hidden = !matches;

      const input = field.querySelector("input, select, textarea");
      if (!input) return;
      input.required = matches;
      input.disabled = !matches;
      if (!matches) input.value = "";
    });
  }

  // Reads a property name (e.g. "Ring size", "Stud Style") back out of a field's own name="properties[X]"
  // attribute, so callers never need to hardcode which conditional field maps to which property.
  function getConditionalFieldPropertyName(field) {
    const input = field ? field.querySelector("input, select, textarea") : null;
    const match = input ? input.name.match(/^properties\[(.+)\]$/) : null;
    return match ? match[1] : null;
  }

  // Every conditional property this picker can ever save (e.g. ["Ring size", "Stud Style"]), regardless of which
  // one is currently active - used to clear out whichever one *isn't* active when saving.
  function getSettingServiceConditionalPropertyNames(root) {
    const { conditionalFields } = getSettingServicePickerFields(root);
    return Array.from(conditionalFields).map(getConditionalFieldPropertyName).filter(Boolean);
  }

  function getSettingServicePickerValues(root) {
    const { jewelleryTypeSelect, settingStyleSelect, metalSelect, conditionalFields } = getSettingServicePickerFields(root);
    const jewelleryType = jewelleryTypeSelect ? jewelleryTypeSelect.value : "";
    const activeConditionalField = findActiveConditionalField(conditionalFields, jewelleryType);
    const conditionalInput = activeConditionalField ? activeConditionalField.querySelector("input, select, textarea") : null;

    return {
      jewelleryType,
      settingStyle: settingStyleSelect ? settingStyleSelect.value : "",
      metal: metalSelect ? metalSelect.value : "",
      // Whichever jewellery-type-specific field is currently visible (Ring size for "Ring", Stud Style for
      // "Studs", ...) - its property name and value, or blank when the current jewellery type has none (e.g. Pendant).
      conditionalPropertyName: activeConditionalField ? getConditionalFieldPropertyName(activeConditionalField) : "",
      conditionalPropertyValue: conditionalInput ? conditionalInput.value : ""
    };
  }

  // True once every required field (Jewellery type, Setting style, Metal, and the active jewellery-type-specific
  // field - Ring size, Stud Style, etc. - when applicable) has a value.
  function isSettingServicePickerComplete(root) {
    const values = getSettingServicePickerValues(root);
    if (!values.jewelleryType || !values.settingStyle || !values.metal) return false;

    const { conditionalFields } = getSettingServicePickerFields(root);
    const hasActiveConditionalField = !!findActiveConditionalField(conditionalFields, values.jewelleryType);
    if (hasActiveConditionalField && !values.conditionalPropertyValue) return false;

    return true;
  }

  // Combines "Setting style" + "Jewellery type" back into the Setting Service's original option value (e.g.
  // "Bezel" + "Ring" -> "Bezel Ring"), then drives the hidden real variant-picker's Metal/Setting Style inputs so
  // its existing variant lookup resolves the matching variant, price and image.
  async function syncSettingServicePicker(root) {
    const values = getSettingServicePickerValues(root);
    if (!values.metal || !values.settingStyle || !values.jewelleryType) return;

    const { realVariantPickerRoot } = getSettingServicePickerFields(root);
    const combinedSettingStyle = `${values.settingStyle} ${values.jewelleryType}`;

    const picker = realVariantPickerRoot?.querySelector("variant-picker");
    if (picker) await waitForVariantPickerProduct(picker);

    const metalInput = findSettingServiceOptionInput(realVariantPickerRoot, "Metal");
    const settingStyleInput = findSettingServiceOptionInput(realVariantPickerRoot, "Setting Style");
    if (!metalInput || !settingStyleInput) return;

    metalInput.value = values.metal;
    settingStyleInput.value = combinedSettingStyle;
    settingStyleInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // Splits an existing variant's raw option values back into the dropdowns, so editing an already-linked setting
  // (cart drawer/page) starts from its current Metal/Setting style/Jewellery type/Ring size/Stud Style choices.
  // `conditionalPropertyValues` is a { "Ring size": ..., "Stud Style": ... } map of the parent's saved values -
  // whichever one matches the field that ends up active (based on the resolved jewellery type) gets applied.
  function preselectSettingServicePicker(root, variant, conditionalPropertyValues) {
    if (!variant) return;

    const { jewelleryTypeSelect, settingStyleSelect, metalSelect, realVariantPickerRoot } = getSettingServicePickerFields(root);
    const metalInput = findSettingServiceOptionInput(realVariantPickerRoot, "Metal");
    const settingStyleInput = findSettingServiceOptionInput(realVariantPickerRoot, "Setting Style");
    const optionIndex = (input) => (input ? parseInt(input.name.replace("option", ""), 10) - 1 : -1);

    const metalValue = variant.options[optionIndex(metalInput)];
    const rawSettingStyle = variant.options[optionIndex(settingStyleInput)];
    if (!metalValue || !rawSettingStyle) return;

    const stylePart = rawSettingStyle.split(" ")[0];
    const typePart = rawSettingStyle.slice(stylePart.length).trim();

    if (metalSelect) metalSelect.value = metalValue;
    if (settingStyleSelect) settingStyleSelect.value = stylePart;
    if (jewelleryTypeSelect) jewelleryTypeSelect.value = typePart;

    toggleJewelleryConditionalFields(root, true);

    if (conditionalPropertyValues) {
      const { conditionalFields } = getSettingServicePickerFields(root);
      const activeField = findActiveConditionalField(conditionalFields, typePart);
      const activeInput = activeField ? activeField.querySelector("input, select, textarea") : null;
      const propertyName = activeField ? getConditionalFieldPropertyName(activeField) : null;
      if (activeInput && propertyName && conditionalPropertyValues[propertyName]) {
        activeInput.value = conditionalPropertyValues[propertyName];
      }
    }
  }

  /* ================================================================================================================
     PRODUCT PAGE: reveal the setting picker, keep the linked properties in sync, and add the Setting Service
     alongside the Loose Stone when the form is submitted.
     ================================================================================================================ */
  // The visible PDP options carry the new business-facing copy, but everything downstream (cart
  // drawer/page gating, parent/child linking, checkSelection) still keys off these two legacy
  // "Stone Preference" values - kept in sync via a hidden input so none of that logic has to change.
  const SETTING_YES_VALUE = "Yes, I need a setting";
  const SETTING_NO_VALUE = "Send stone loose";

  function initProductPage() {
    document.querySelectorAll("[data-loose-stone-picker]").forEach((wrapper) => {
      const settingFormId = wrapper.dataset.settingFormId;
      const parentFormId = wrapper.dataset.parentFormId;
      const picker = wrapper.querySelector("[data-loose-stone-setting-picker]");
      const selectionInput = wrapper.querySelector("[data-setting-selection-input]");
      const settingIdInput = wrapper.querySelector("[data-setting-id-input]");
      const errorMessage = wrapper.querySelector("[data-setting-error]");
      const legacyPreferenceInput = wrapper.querySelector("[data-legacy-stone-preference-input]");
      const referenceImageInput = wrapper.querySelector("[data-reference-image-input]");
      const detailFields = wrapper.querySelector("[data-setting-detail-fields]");
      const jewelleryTypeSelect = wrapper.querySelector('select[name="properties[Jewellery type]"]');
      const settingStyleSelect = wrapper.querySelector('select[name="properties[Setting style]"]');
      const metalSelect = wrapper.querySelector('select[name="properties[Metal]"]');

      function isChecked() {
        const checked = wrapper.querySelector('input[type="radio"]:checked');
        return !!checked && checked.value === SETTING_YES_VALUE;
      }

      function togglePicker() {
        const checked = wrapper.querySelector('input[type="radio"]:checked');
        const needsSetting = !!checked && checked.value === SETTING_YES_VALUE;
        if (picker) picker.hidden = !needsSetting;
        if (errorMessage) errorMessage.hidden = true;

        // Every radio's own value is saved into this same property - "Yes"/"No" keep the legacy strings that
        // downstream cart/checkout gating already keys off, and any other option (e.g. "Request advice before
        // proceeding") is carried through as-is instead of being collapsed into the "No" value.
        if (legacyPreferenceInput) {
          if (!checked) {
            legacyPreferenceInput.value = "";
          } else if (needsSetting) {
            legacyPreferenceInput.value = SETTING_YES_VALUE;
          } else if (checked.value === SETTING_NO_VALUE) {
            legacyPreferenceInput.value = "Send stone loose";
          } else {
            legacyPreferenceInput.value = checked.value;
          }
        }

        // Only the new detail fields are gated here - the existing Setting Service variant-picker
        // keeps its own behaviour untouched.
        if (detailFields) {
          detailFields.querySelectorAll("input, select, textarea").forEach((field) => {
            field.disabled = !needsSetting;
          });
        }
        toggleJewelleryConditionalFields(wrapper, needsSetting);

        // "No"/"Request advice" must never carry setting-related properties into the cart.
        [selectionInput, settingIdInput].forEach((input) => {
          if (!input) return;
          input.disabled = !needsSetting;
          if (!needsSetting) input.value = "";
        });
      }

      wrapper.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener("change", togglePicker);
      });
      if (jewelleryTypeSelect) {
        jewelleryTypeSelect.addEventListener("change", () => toggleJewelleryConditionalFields(wrapper, isChecked()));
      }
      [jewelleryTypeSelect, settingStyleSelect, metalSelect].forEach((select) => {
        if (!select) return;
        select.addEventListener("change", () => syncSettingServicePicker(wrapper));
      });
      togglePicker();
      syncSettingServicePicker(wrapper);

      const settingForm = document.forms[settingFormId];
      if (settingForm && selectionInput) {
        settingForm.addEventListener("variant:change", (event) => {
          selectionInput.value = event.detail.variant ? event.detail.variant.title : "";
        });
      }

      const parentForm = document.forms[parentFormId];
      if (!parentForm) return;

      // When a setting is selected, this capture listener owns the submit. It prevents the theme
      // handler and sends both line items with one batched Shopify add request.
      document.addEventListener("submit", async function (event) {
        if (event.target !== parentForm) return;

        const checked = wrapper.querySelector('input[type="radio"]:checked');
        if (!checked || checked.value !== SETTING_YES_VALUE) return;

        const variant = settingFormId ? getSettingVariant(settingFormId) : null;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (!settingForm || !variant || !variant.available) {
          if (errorMessage) errorMessage.hidden = false;
          picker?.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }

        selectionInput.disabled = false;
        settingIdInput.disabled = false;
        selectionInput.value = variant.title;
        // Generated fresh at the moment the item is actually added to the cart, then reused as-is for the
        // Setting Service add below, so both line items carry the exact same timestamp.
        const settingId = generateSettingId();
        settingIdInput.value = settingId;

        const quantity = parseInt(parentForm.quantity?.value, 10) || 1;

        if (!parentForm.checkValidity()) {
          parentForm.reportValidity();
          return;
        }

        const submitButtons = Array.from(parentForm.elements).filter((element) => element.type === "submit");
        submitButtons.forEach((button) => {
          button.setAttribute("disabled", "disabled");
          button.setAttribute("aria-busy", "true");
        });

        // A file property can only travel as multipart/form-data - it can't be embedded in the
        // JSON "items" request used below, so a reference image forces the two-request path.
        const hasReferenceImage = !!(referenceImageInput && referenceImageInput.files && referenceImageInput.files.length);

        const sectionsToBundle = prepareBundledSections();
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

        try {
          let responseJson;

          if (hasReferenceImage) {
            // Add the Loose Stone (with its file) first, and only add the Setting Service afterwards
            // if that succeeds - the same "no orphan Setting Service line if the Loose Stone add fails"
            // guarantee as the bundled JSON path below, just via two sequential requests instead of one.
            const parentFormData = new FormData(parentForm);
            parentFormData.set("sections", sectionsToBundle.join(","));
            parentFormData.set("sections_url", `${Shopify.routes.root}variants/${parentForm.id.value}`);

            const parentResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: "POST",
              headers: { "X-Requested-With": "XMLHttpRequest" },
              body: parentFormData
            });
            responseJson = await parentResponse.json();

            if (!parentResponse.ok) {
              parentForm.dispatchEvent(new CustomEvent("cart:error", {
                bubbles: true,
                detail: { error: responseJson.description }
              }));
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              return;
            }

            const settingResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
              },
              body: JSON.stringify({ id: variant.id, quantity, properties: { _setting_id: settingId } })
            });

            if (!settingResponse.ok) {
              const settingResponseJson = await settingResponse.json();
              parentForm.dispatchEvent(new CustomEvent("cart:error", {
                bubbles: true,
                detail: { error: settingResponseJson.description }
              }));
            }
          } else {
            const parentItem = { id: parentForm.id.value, quantity, properties: {} };
            new FormData(parentForm).forEach((value, key) => {
              const propertyMatch = key.match(/^properties\[(.+)\]$/);
              if (propertyMatch) {
                parentItem.properties[propertyMatch[1]] = value;
              } else if (key === "selling_plan") {
                parentItem.selling_plan = value;
              }
            });

            const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
              },
              body: JSON.stringify({
                items: [
                  parentItem,
                  { id: variant.id, quantity, properties: { _setting_id: settingId } }
                ],
                sections: sectionsToBundle.join(","),
                sections_url: `${Shopify.routes.root}variants/${parentItem.id}`
              })
            });
            responseJson = await response.json();

            if (!response.ok) {
              parentForm.dispatchEvent(new CustomEvent("cart:error", {
                bubbles: true,
                detail: { error: responseJson.description }
              }));
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              return;
            }
          }

          if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
            window.location.href = `${Shopify.routes.root}cart`;
            return;
          }

          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent.sections = responseJson.sections;
          parentForm.dispatchEvent(new CustomEvent("variant:add", {
            bubbles: true,
            detail: { items: responseJson.items || [responseJson], cart: cartContent }
          }));
          dispatchCartChange(cartContent, "variant:add");
        } catch (error) {
          console.error("Could not add loose stone and setting:", error);
          parentForm.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: { error: "Unable to add this item to the cart." }
          }));
        } finally {
          submitButtons.forEach((button) => {
            button.removeAttribute("disabled");
            button.removeAttribute("aria-busy");
          });
          document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        }

        return;

        /*
         * ─────────────────────────────────────────────────────────────────────────────────────────────
         * FIX: Do not fire the Setting Service add blindly in parallel with the Loose Stone add anymore.
         * If the Loose Stone add itself fails (e.g. Shopify's "max quantity already in cart" error when
         * the same stone is added a second time), the Setting Service must NOT be added either -
         * otherwise we get an orphan Setting Service line with nothing linked to it.
         *
         * We can't simply await the theme's own submit handler (it runs after this one and we don't
         * control it), so instead we transparently intercept the very next `cart/add.js` call - which
         * will be the theme's own request to add the Loose Stone - inspect its result, and only then
         * decide whether to add the Setting Service. The original fetch is restored immediately after
         * catching that one call so nothing else is affected.
         * ─────────────────────────────────────────────────────────────────────────────────────────────
         */
        const originalFetch = window.fetch;
        let intercepted = false;

        window.fetch = function (input, init) {
          const url = typeof input === "string" ? input : input?.url;
          const isMainAddCall = !intercepted && url && url.indexOf("cart/add.js") !== -1;

          if (!isMainAddCall) {
            return originalFetch.apply(this, arguments);
          }

          intercepted = true;
          window.fetch = originalFetch; // restore right away - only ever intercept this one call

          const addRequest = originalFetch.apply(this, arguments);

          addRequest
            .then((response) => response.clone().json())
            .then((result) => {
              // Shopify returns a "status" field (e.g. 422) on failure - out of stock, quantity limits, etc.
              // A successful add response is the line item itself and has no "status" field.
              if (!result || result.status) {
                console.log("Loose Stone add failed - skipping Setting Service add:", result);
                return;
              }

              fetch(`${Shopify.routes.root}cart/add.js`, {
                method: "POST",
                keepalive: true,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  id: variant.id,
                  quantity,
                  properties: { _setting_id: settingId }
                })
              })
                .then(() => document.dispatchEvent(new CustomEvent("cart:refresh")))
                .catch((err) => console.log("Setting Service add error:", err));
            })
            .catch((err) => console.log("Could not read Loose Stone add response:", err));

          return addRequest;
        };

        // Safety net: if for some reason the theme never calls cart/add.js after this submit (e.g. its own
        // client-side validation blocks it earlier), restore fetch so we don't leak the intercept forever.
        setTimeout(() => {
          if (!intercepted) window.fetch = originalFetch;
        }, 5000);
      }, true);
    });
  }

  /* ================================================================================================================
     CART DRAWER / CART PAGE: "Stone Preference" radios, the setting-service modal, and keeping the parent/child
     line items in sync (checkout gating, cascade removal, quantity mirroring).
     ================================================================================================================ */
  function checkSelection() {
    const wrappers = document.querySelectorAll('[data-loose-stone="true"]');
    const checkoutBtns = document.querySelectorAll('button[name="checkout"], .cart__checkout, .cart-drawer__footer button[name="checkout"], .cart-page button[name="checkout"]');
    let allSelected = true;

    wrappers.forEach((wrapper) => {
      const checked = wrapper.querySelector('input[type="radio"]:checked');
      if (!checked) {
        allSelected = false;
        return;
      }
      if (checked.value === SETTING_YES_VALUE && !wrapper.dataset.childKey) {
        allSelected = false;
      }
    });

    checkoutBtns.forEach((btn) => { btn.disabled = !allSelected; });
  }

  async function updateLineItem(itemKey, payload, sectionsToBundle) {
    return (await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: itemKey, sections: sectionsToBundle.join(","), ...payload })
    })).json();
  }

  const AUTO_OPEN_SETTING_MODAL_KEY = "loose-stone:auto-open-setting-modal-key";

  // A property update changes a cart line's key (Shopify keys are variant_id + a hash of the properties), so the
  // key captured before this update no longer identifies the line afterwards. Re-resolve it from the response
  // using the variant (stable prefix of the pre-update key) plus the properties we just asked the server to set.
  function resolveUpdatedItemKey(cartContent, previousKey, expectedProperties) {
    const variantId = previousKey.split(":")[0];
    const match = cartContent.items.find((item) => {
      if (String(item.variant_id) !== variantId) return false;
      const properties = item.properties || {};
      return (properties["Stone Preference"] || "") === (expectedProperties["Stone Preference"] || "")
        && (properties["_setting_id"] || "") === (expectedProperties["_setting_id"] || "");
    });
    return match ? match.key : previousKey;
  }

  // Polls (via rAF, not an arbitrary timeout) for the setting-service modal to exist in the DOM once the cart
  // section HTML has re-rendered with the line item's (possibly new) key.
  async function waitForElementId(id, maxFrames) {
    for (let frame = 0; frame < (maxFrames || 30); frame++) {
      const el = document.getElementById(id);
      if (el) return el;
      await new Promise(requestAnimationFrame);
    }
    return document.getElementById(id);
  }

  function openSettingModal(itemKey) {
    waitForElementId(`setting-service-modal-${itemKey}`).then((modal) => {
      if (!modal) return;
      // This modal has just been rendered fresh (switching to "Yes, I need a setting" with nothing linked yet) and
      // may not have gone through preselectAllSettingModals()'s wiring pass yet, depending on exactly when the
      // cart section HTML swap that produced it happens to run relative to that pass. Wire it here too so its
      // Jewellery type / Setting style / Metal dropdowns are guaranteed to be interactive before it opens.
      const content = modal.querySelector("[data-setting-service-modal-content]");
      if (content) wireSettingModalPicker(content);
      modal.show();
    });
  }

  async function syncSettingModal(modal) {
    const content = modal.querySelector("[data-setting-service-modal-content]");
    if (!content) return;
    wireSettingModalPicker(content);
    await preselectSettingVariant(content.dataset.settingForm, content.dataset.selectedVariantId, content);
  }

  // Cart sections may be replaced dynamically. Open the modal referenced by the clicked
  // setting button directly, and restore its selector from its own linked cart item.
  document.addEventListener("click", async function (event) {
    const control = event.target.closest('[aria-controls^="setting-service-modal-"]');
    if (!control) return;

    const modal = document.getElementById(control.getAttribute("aria-controls"));
    if (!modal || modal.tagName.toLowerCase() !== "x-modal") return;

    event.preventDefault();
    event.stopImmediatePropagation();
    await syncSettingModal(modal);
    modal.show();
  }, true);

  // ───────────────────────────────────── // STONE PREFERENCE RADIO CHANGE // ───────────────────────────────────── //
  document.addEventListener("change", async function (e) {
    if (!e.target.matches('[data-loose-stone="true"] input[type="radio"]')) return;

    const wrapper = e.target.closest('[data-loose-stone="true"]');
    const itemKey = wrapper?.dataset?.key;
    const childKey = wrapper?.dataset?.childKey;
    const value = e.target.value;
    if (!itemKey) return;

    try {
      dispatchLoadingStart();

      const lineItem = wrapper.closest("line-item");
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { stonePreference: value } }));

      const sectionsToBundle = prepareBundledSections();
      const newProperties = { ...parseExistingProperties(wrapper), "Stone Preference": value };

      // Switching away from "Yes, I need a setting" removes the linked Setting Service (below), so the Loose
      // Stone must not keep holding onto properties that described that now-gone setting. "Stone Preference"
      // itself is left untouched above so it reflects the newly selected option.
      if (value !== SETTING_YES_VALUE) {
        delete newProperties["Setting selection"];
        delete newProperties["_setting_id"];
        delete newProperties["Jewellery type"];
        delete newProperties["Setting style"];
        delete newProperties["Metal"];
        delete newProperties["Ring size"];
        delete newProperties["Stud Style"];
      }

      let cartContent = await updateLineItem(itemKey, { properties: newProperties }, sectionsToBundle);

      // Switching away from "Yes, I need a setting" orphans the linked Setting Service: remove it too.
      if (value !== SETTING_YES_VALUE && childKey) {
        cartContent = await updateLineItem(childKey, { quantity: 0 }, prepareBundledSections());
      }

      const updatedKey = resolveUpdatedItemKey(cartContent, itemKey, newProperties);
      // Switching to "Yes, I need a setting" with nothing linked yet: open the existing Setting Service popup as
      // part of this same interaction instead of waiting for a separate "Choose your setting" click.
      const opensSettingModal = value === SETTING_YES_VALUE && !childKey;

      if (isCartPage()) {
        // No JS survives the reload below, so stash which line to open the popup for; init() consumes it once
        // the reloaded cart page is ready.
        if (opensSettingModal) {
          try { sessionStorage.setItem(AUTO_OPEN_SETTING_MODAL_KEY, updatedKey); } catch (err) {}
        }
        window.location.reload();
        return;
      }

      dispatchLoadingEnd();

      const lineItemAfterChange = cartContent.items.filter((item) => item.key === updatedKey);
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: { quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity, cart: cartContent }
      }));

      dispatchCartChange(cartContent);

      if (opensSettingModal) {
        openSettingModal(updatedKey);
      }

      setTimeout(checkSelection, 100);
    } catch (err) {
      console.log("Cart update error:", err);
      dispatchLoadingEnd();
    }
  });

  // Wires the modal's Jewellery type / Setting style / Metal dropdowns exactly like the product page does -
  // same shared syncSettingServicePicker/toggleJewelleryConditionalFields, just without the product page's
  // outer "Yes/No/Request advice" gate, since the modal only ever appears once "Yes, I need a setting" is active.
  function wireSettingModalPicker(content) {
    if (content.dataset.settingPickerWired) return;
    content.dataset.settingPickerWired = "true";

    const jewelleryTypeSelect = content.querySelector('select[name="properties[Jewellery type]"]');
    const settingStyleSelect = content.querySelector('select[name="properties[Setting style]"]');
    const metalSelect = content.querySelector('select[name="properties[Metal]"]');

    if (jewelleryTypeSelect) {
      jewelleryTypeSelect.addEventListener("change", () => toggleJewelleryConditionalFields(content, true));
    }
    [jewelleryTypeSelect, settingStyleSelect, metalSelect].forEach((select) => {
      if (!select) return;
      select.addEventListener("change", () => syncSettingServicePicker(content));
    });
  }

  function preselectAllSettingModals() {
    document.querySelectorAll("[data-setting-service-modal-content]").forEach((content) => {
      wireSettingModalPicker(content);
      preselectSettingVariant(content.dataset.settingForm, content.dataset.selectedVariantId, content);
    });
  }

  // Consumes the flag stashed (see AUTO_OPEN_SETTING_MODAL_KEY above) right before a cart-page reload so the
  // popup opens once on the reloaded page, tied to that specific interaction rather than every cart page load.
  function consumeAutoOpenSettingModal() {
    let key;
    try {
      key = sessionStorage.getItem(AUTO_OPEN_SETTING_MODAL_KEY);
    } catch (err) {
      return;
    }
    if (!key) return;
    try { sessionStorage.removeItem(AUTO_OPEN_SETTING_MODAL_KEY); } catch (err) {}
    document.getElementById(`setting-service-modal-${key}`)?.show();
  }

  // ───────────────────────────────────── // MODAL CONFIRM // ───────────────────────────────────── //
  document.addEventListener("click", async function (e) {
    const button = e.target.closest("[data-confirm-setting-selection]");
    if (!button) return;

    const content = button.closest("[data-setting-service-modal-content]");
    if (!content) return;

    const settingFormId = content.dataset.settingForm;
    const parentKey = content.dataset.parentKey;
    const existingChildKey = content.dataset.existingChildKey;
    const modalId = content.dataset.modalId;

    let errorMessage = content.querySelector("[data-setting-modal-error]");
    if (!errorMessage) {
      errorMessage = document.createElement("p");
      errorMessage.className = "text-error text-sm";
      errorMessage.setAttribute("data-setting-modal-error", "");
      content.appendChild(errorMessage);
    }

    // Same validation as the product page: Jewellery type, Setting style, Metal (and Ring size when applicable)
    // must all be chosen before a setting can be confirmed.
    if (!isSettingServicePickerComplete(content)) {
      errorMessage.textContent = "Please choose a Jewellery type, Setting style and Metal.";
      errorMessage.hidden = false;
      return;
    }

    const variant = getSettingVariant(settingFormId, content);

    if (!variant || !variant.available) {
      errorMessage.textContent = "Please choose an available setting.";
      errorMessage.hidden = false;
      return;
    }

    errorMessage.hidden = true;
    button.disabled = true;
    dispatchLoadingStart();

    try {
      // Reuse the existing relationship's timestamp when just swapping the variant; generate a fresh one only
      // when this Loose Stone doesn't have a Setting Service linked yet.
      const settingId = content.dataset.parentSettingId || generateSettingId();

      if (existingChildKey) {
        await updateLineItem(existingChildKey, { quantity: 0 }, prepareBundledSections());
      }

      await (await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variant.id, quantity: 1, properties: { _setting_id: settingId } })
      })).json();

      const parentWrapper = document.querySelector(`[data-loose-stone="true"][data-key="${CSS.escape(parentKey)}"]`);
      const existingProperties = parseExistingProperties(parentWrapper);
      const pickerValues = getSettingServicePickerValues(content);

      const newParentProperties = {
        ...existingProperties,
        "Stone Preference": SETTING_YES_VALUE,
        "Setting selection": variant.title,
        _setting_id: settingId,
        "Jewellery type": pickerValues.jewelleryType,
        "Setting style": pickerValues.settingStyle,
        "Metal": pickerValues.metal
      };

      // Only one jewellery-type-specific property (Ring size, Stud Style, ...) ever applies at a time - clear
      // every one of them first, then set only whichever is actually active, so switching Jewellery type never
      // leaves a stale property (e.g. a leftover Ring size after switching to Studs) behind.
      getSettingServiceConditionalPropertyNames(content).forEach((name) => delete newParentProperties[name]);
      if (pickerValues.conditionalPropertyName && pickerValues.conditionalPropertyValue) {
        newParentProperties[pickerValues.conditionalPropertyName] = pickerValues.conditionalPropertyValue;
      }

      const cartContent = await updateLineItem(parentKey, {
        properties: newParentProperties
      }, prepareBundledSections());

      // Keep this already-mounted modal in sync until Shopify's refreshed cart markup replaces it.
      // Otherwise reopening it before a page refresh would show its old default variant.
      content.dataset.selectedVariantId = String(variant.id);
      document.getElementById(modalId)?.hide();

      if (isCartPage()) {
        window.location.reload();
        return;
      }

      dispatchLoadingEnd();
      dispatchCartChange(cartContent);
    } catch (err) {
      console.log("Setting selection update error:", err);
      dispatchLoadingEnd();
    } finally {
      button.disabled = false;
    }
  });

  // ───────────────────────────────────── // CASCADE REMOVAL / QUANTITY MIRRORING (PARENT -> CHILD) // ───────────────────────────────────── //
  async function cascadeQuantityChange(parentKey, childKey, targetQuantity, scopeEl) {
    dispatchLoadingStart();

    const lineItem = scopeEl.closest("line-item") || scopeEl.closest("tr");
    lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));

    const sectionsToBundle = prepareBundledSections();
    const updates = {
      [parentKey]: targetQuantity
    };
    if (childKey) {
      updates[childKey] = targetQuantity;
    }
    
    try {
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates, sections: sectionsToBundle.join(",") })
      })).json();

      if (isCartPage()) {
        window.location.reload();
        return;
      }

      dispatchLoadingEnd();

      const updatedLine = cartContent.items.find((item) => item.key === parentKey);
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: { quantity: updatedLine ? updatedLine.quantity : 0, cart: cartContent }
      }));

      dispatchCartChange(cartContent);
      setTimeout(checkSelection, 100);
    } catch (err) {
      console.log("Cascade quantity update error:", err);
      dispatchLoadingEnd();
    }
  }

  document.addEventListener("click", function (e) {
    const link = e.target.closest('a[href*="/cart/change"]');
    if (!link) return;

    const scopeEl = link.closest("line-item-quantity[data-linked-child-key]");
    if (!scopeEl) return;

    e.preventDefault();
    e.stopPropagation();

    const url = new URL(link.href);
    const parentKey = url.searchParams.get("id");
    const targetQuantity = parseInt(url.searchParams.get("quantity"), 10) || 0;
    cascadeQuantityChange(parentKey, scopeEl.dataset.linkedChildKey, targetQuantity, scopeEl);
  }, true);

  document.addEventListener("change", function (e) {
    if (!e.target.matches("[data-line-key]")) return;

    const scopeEl = e.target.closest("line-item-quantity[data-linked-child-key]");
    if (!scopeEl) return;

    e.preventDefault();
    e.stopPropagation();

    const parentKey = e.target.getAttribute("data-line-key");
    const targetQuantity = parseInt(e.target.value, 10) || 0;
    cascadeQuantityChange(parentKey, scopeEl.dataset.linkedChildKey, targetQuantity, scopeEl);
  }, true);

  // ───────────────────────────────────── // RE-RENDER HOOKS // ───────────────────────────────────── //
  document.documentElement.addEventListener("cart:change", () => {
    setTimeout(checkSelection, 100);
    preselectAllSettingModals();
  });

  document.addEventListener("cart:refresh", () => {
    setTimeout(checkSelection, 100);
  });

  // ───────────────────────────────────── // INITIAL SETUP (DOM-dependent) // ───────────────────────────────────── //
  function init() {
    initProductPage();
    checkSelection();
    setTimeout(checkSelection, 300);
    preselectAllSettingModals();
    if (isCartPage()) consumeAutoOpenSettingModal();

    const cartDrawer = document.querySelector("cart-drawer");
    const cartPage = document.querySelector(".cart-page");
    const observer = new MutationObserver(checkSelection);

    if (cartDrawer) observer.observe(cartDrawer, { childList: true, subtree: true });
    if (cartPage) observer.observe(cartPage, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
/* ===================== END loose stone option ===================== */
//START Code to hide add to cart button for auction products //
var checkWidget = setInterval(function() {
    console.log('Checking widget...', $('.tpa-product-widget-wrapper').length);

    if ($('.tpa-product-widget-wrapper').length) {
        console.log('✅ Widget FOUND');
        console.log($('.tpa-product-widget-wrapper'));

        clearInterval(checkWidget);

        console.log(
            'Product forms found:',
            $('.shopify-product-form').length
        );

        $('.shopify-product-form').hide();

        console.log('✅ Product form hide attempted');
    }
}, 500);
//END Code to hide add to cart button for auction products //